import fetchRefreshToken from './fetchRefreshToken'

const fetchPartnerAddEdit = async (payload, action, id) => {
   console.log(payload)
  const newToken = await fetchRefreshToken().then(response => response)
    let response
    if(action === "POST"){
    response = await fetch(`${process.env.REACT_APP_FETCH_DEV}rest/partners`, {
      method: action,
      headers:{
        "Authorization": `Bearer ${newToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => response)
  } else if(action === "PUT"){
      response = await fetch(`${process.env.REACT_APP_FETCH_DEV}rest/partners/${id}`, {
      method: action,
      headers:{
        "Authorization": `Bearer ${newToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
  }

    return response
 }

  export default fetchPartnerAddEdit